var _defs, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .blue2 { fill: #A0DAFF80; }\n      .blue3 { fill: #64B5F6A0; }\n      .blue4 { fill: #42A5F5B0; }\n      .text { \n        fill: #DEF;\n        stroke: #00A;\n        stroke-width: 4px;\n        stroke-linecap: butt;\n        stroke-linejoin: miter;\n        font-family: Arial, sans-serif; \n        font-size: 9em; \n        font-weight: bold; \n      }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 130,
    r: 50,
    className: "blue3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 100,
    r: 50,
    className: "blue4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 60,
    r: 50,
    className: "blue2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorLogo);
export default __webpack_public_path__ + "static/media/connector_logo.051b7ef258fd763e3b97f7556e0c3ed4.svg";
export { ForwardRef as ReactComponent };